import ProductDocumentationList from './ProductDocumentationList';
import ProductDocumentationDetail from './ProductDocumentationDetail';

export const routes = [
    {
        path: '/',
        exact: true,
        render: routeContext => props => {
            return <ProductDocumentationList {...props} {...routeContext}/>
        }
    },
    {
        path: '/:sku',
        exact: true,
        render: routeContext => props => {
            const {sku} = props.match.params;
            return <ProductDocumentationDetail {...props} sku={sku}/>;
        }
    }
];